import React from 'react';
import { ShieldCheck } from 'lucide-react';
import PortalLoginShell from './PortalLoginShell';

export default function AdminLogin() {
  return (
    <PortalLoginShell
      badge="For Staff"
      title="Admin Login"
      subtitle="Access the administrative console to manage applications, partners and student records."
      expectedRole="admin"
      onSuccessPath="/admin-dashboard"
      iconBg="bg-tge-navy"
      Icon={ShieldCheck}
      emailPlaceholder="admin@trueglobaleducation.com"
      testidPrefix="admin-login"
      footerLink={null}
    />
  );
}
